import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import AppAppBar from '../../components/layout/AppAppBar';
import congratulationsGif from '../../assets/Congratulations_20260102065157.gif';
import downloadApkGif from '../../assets/downlaod_APK.gif';

// Add global definition
declare global {
  interface Window {
    gtag: (
      cmd: string,
      action: string,
      params?: {
        event_category?: string;
        event_label?: string;
        page_location?: string;
        [key: string]: any;
      }
    ) => void;
  }
}

export default function PaymentSuccessPage() {
  const isLoggedIn = !!(localStorage.getItem('user_data') || localStorage.getItem('profile') || localStorage.getItem('is_logged_in'));

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>
      {/* Common Navbar */}
      <AppAppBar mode="light" toggleColorMode={() => { }} simpleNavbar={true} transparentMode={true} showProfile={isLoggedIn} showLogin={false} />

      <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minHeight: 'calc(100vh - 60px)', bgcolor: '#fff', pt: 11 }}>
        <Typography
          variant="h4"
          sx={{
            mb: 4,
            fontWeight: 800,
            fontFamily: 'General-Sans-bold',
            color: '#000',
            position: 'relative',
            display: 'inline-block',
            zIndex: 1
          }}
        >
          Payment Status
          <Box
            sx={{
              position: 'absolute',
              bottom: '6px',
              right: '-5px',
              width: '60%',
              height: '14px',
              bgcolor: '#FFC107',
              zIndex: -1,
              borderRadius: '20px'
            }}
          />
        </Typography>

        {/* Congratulations GIF */}
        <Box sx={{ width: 280, height: 280, mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img
            src={congratulationsGif}
            data-track="gif"
            data-name="payment_success_celebration"
            alt="Congratulations"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </Box>

        {/* Dynamic Content based on Login Status */}
        {(() => {
          return (
            <>
              <Typography 
                variant="h4" 
                sx={{ 
                  color: '#3F51B5', 
                  fontWeight: 800, 
                  mb: 1, 
                  fontFamily: 'General-Sans-bold', 
                  textAlign: 'center', 
                  fontSize: { xs: '1.8rem', sm: '2rem' } 
                }}
              >
                {isLoggedIn ? "Payment Processed" : "Congratulations"}
              </Typography>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 600, 
                  color: '#1A237E', 
                  textAlign: 'center',
                  px: 2,
                  mb: 4,
                  fontFamily: 'General-Sans-bold',
                  fontSize: { xs: '1.1rem', sm: '1.3rem' },
                  lineHeight: 1.4,
                  opacity: 0.85
                }}
              >
                Wait 24 Hours, Payment Will Be Received
              </Typography>
            </>
          );
        })()}

        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#000' }}>
          Ready for the Next Offer?
        </Typography>

        <Button
          variant="contained"
          fullWidth
          onClick={() => {
            window.location.href = "/";
          }}
          sx={{
            background: 'linear-gradient(180deg, #FFECB3 0%, #FFC107 100%)',
            color: '#000',
            py: 1,
            px: 2,
            borderRadius: '16px',
            maxWidth: 335,
            textTransform: 'none',
            boxShadow: '0 8px 20px rgba(255, 193, 7, 0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 0,
            '&:hover': {
              background: 'linear-gradient(180deg, #FFE082 0%, #FFB300 100%)',
              boxShadow: '0 10px 25px rgba(255, 193, 7, 0.4)',
            }
          }}
        >
          <Box sx={{ textAlign: 'left' }}>
            <Typography variant="h6" sx={{
              fontWeight: 700,
              fontSize: '26.64px',
              lineHeight: '40px',
              fontFamily: 'Poppins, sans-serif',
              width: 'auto',
              whiteSpace: 'nowrap',
              mb: 0
            }}>
              Next Offer
            </Typography>
            <Typography variant="body2" sx={{
              fontWeight: 500,
              fontSize: '17.76px',
              lineHeight: '27px',
              fontFamily: 'Poppins, sans-serif',
              width: 'auto',
              whiteSpace: 'nowrap',
              opacity: 0.9
            }}>
              Claim your next reward now
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img
              src={downloadApkGif}
              alt="Download"
              style={{ width: '66px', height: '66px', objectFit: 'contain' }}
            />
          </Box>
        </Button>
      </Container>
    </Box>
  );
}